export default "__VITE_ASSET__5wS$sdvl__"